import type { Company, CEOParams, ThemeData, PrestigeBonuses } from '../types';

export function createCompany(
  name: string,
  _ceo: CEOParams,
  themeData: ThemeData,
  prestigeBonuses: PrestigeBonuses,
  isHardMode: boolean,
): Company {
  const baseStartingFunds = isHardMode
    ? themeData.balance.hardMode.startingFunds
    : themeData.balance.startingFunds;

  return {
    id: 'company_1',
    name,
    funds: baseStartingFunds + prestigeBonuses.startingFunds,
    totalRevenue: 0,
    totalExpenses: 0,
    reputation: 10 + prestigeBonuses.reputationBonus,
    fans: 0,
    level: 1,
    xp: 0,
    xpToNextLevel: 100,
    currentYear: 1,
    currentWeek: 1,
    currentTick: 0,
    totalProductsReleased: 0,
    hallOfFameCount: 0,
    prestigeLevel: prestigeBonuses.startingFunds > 0 ? Math.ceil(prestigeBonuses.startingFunds / themeData.balance.prestige.startingFundsPerLevel) : 0,
    prestigeBonuses,
    isHardMode,
    weeksInDebt: 0,
  };
}

export const DEFAULT_PRESTIGE_BONUSES: PrestigeBonuses = {
  startingFunds: 0,
  xpMultiplier: 1,
  reputationBonus: 0,
  unlockedFromStart: [],
};
